import * as React from 'react';
import Agreement from '../containers/Agreement';

export default (props) => (<Agreement {...props} />);
